import { render, staticRenderFns } from "./addbug.vue?vue&type=template&id=62bdc252&scoped=true&"
import script from "./addbug.vue?vue&type=script&lang=js&"
export * from "./addbug.vue?vue&type=script&lang=js&"
import style0 from "./addbug.vue?vue&type=style&index=0&id=62bdc252&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bdc252",
  null
  
)

export default component.exports